import { cryptoPortfolioService } from "../httpService/cryptoPorfolio.service";

export async function tryLogout() {
    return await cryptoPortfolioService.post('/user/logout');
}